import React, { useState, useEffect, useMemo } from "react";
import "../Assests/Scss/Participation.scss";
import {
  AssessmentName,CAssessmentName

} from "../../Student/Reusablecomponents/RegularFunctions";
import Loading from "../../Student/Reusablecomponents/Loading";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

import { StateDetailsData } from "../../Redux/Reducers/HQAdmin/StatePerformanceDetails";
import { AllSubjectData } from "../../Redux/Reducers/HQAdmin/PerformanceOverallSubjects";
import RLineTrends from "./RLineTrends";
import StateTrends from "./StateTrends";
import {Testcolors} from "../../ReusableComponents/CommonFunctions";
import { RiFileExcel2Fill } from "react-icons/ri";
import XLSX from "xlsx-js-style";
const RegionPerformanceDrillDown = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelecteRegionData = useSelector((state) => state.SubjectsData);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);

  const Colors = ["#9acb64", "#435393","#CCABD8", "#FFDD94", "#FA897B", "#D0E6A5"];

  const [Load, SetLoad] = useState(false);

  const [NSData, SetNSData] = useState([]);
  const [RegionP, SetRegionP] = useState();
  const [StateWisedata, SetStateWisedata] = useState();
  const [RegionIds, SetRegionIds] = useState();
  const [StateIds, SetStateIds] = useState();

  const [Subjects, SetSubjects] = useState();
  const [SelectSUb, SetSelectSub] = useState();

  const [SelectRegionDetails, SetSelectRegionDetails] = useState({
    RegionName: SelecteRegionData?.RegionDetails?.[0].display || SelecteRegionData?.RegionDetails?.[0]?.Region,
    RegionId: SelecteRegionData?.RegionDetails?.[0].value || SelecteRegionData?.RegionDetails?.[0]?.Regionid,
  });

  const NationalPerformance = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/InstitutionAdmin/GetNationalPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          NationalRegionPerformance();
          SetNSData(res.data);
        } else {
          SetStateWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
          SetLoad((prev) => !prev);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const NationalRegionPerformance = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/InstitutionAdmin/GetRegionPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const regions = [...new Set(res.data.map((item) => item.region))];
        const regionIDs = Array.from(
          res.data
            .reduce(
              (map, item) =>
                map.set(item.region, {
                  display: item.region,
                  value: item.regionId,
                }),
              new Map()
            )
            .values()
        );
        SetRegionIds(regionIDs);
        const subjects = [...new Set(res.data.map((item) => item.subjectName))];
        const regionData = regions.map((region) => {
          const regionSubjects = res.data.filter(
            (item) => item.region === region
          );
          const subjectPercentages = subjects.reduce((acc, subject) => {
            acc[subject] =
              regionSubjects.find((item) => item.subjectName === subject)
                ?.percentage || "N/A";
            return acc;
          }, {});
          return { region, ...subjectPercentages };
        });

        SetRegionP(regionData);
        SetLoad((prev) => !prev);
        StatePerformance();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const StatePerformance = async () => {
    SetStateIds();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/InstitutionAdmin/GetStatePerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}&RegionId=${SelectRegionDetails?.RegionId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].state) {
          const regions = [...new Set(res.data.map((item) => item.state))];
          const regionIDs = Array.from(
            res.data
              .reduce(
                (map, item) =>
                  map.set(item.state, {
                    display: item.state,
                    value: item.stateId,
                  }),
                new Map()
              )
              .values()
          );
          SetStateIds(regionIDs);
          const subjects = [
            ...new Set(res.data.map((item) => item.subjectName)),
          ];
          const regionData = regions.map((state) => {
            const regionSubjects = res.data.filter(
              (item) => item.state === state
            );
            const subjectPercentages = subjects.reduce((acc, subject) => {
              acc[subject] =
                regionSubjects.find((item) => item.subjectName === subject)
                  ?.percentage || "N/A";
              return acc;
            }, {});
            return { state, ...subjectPercentages };
          });

          SetStateWisedata(regionData);
        } else {
          SetStateWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (SelectDate?.value > 0){ NationalPerformance();}
     else{   SetStateWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
      SetRegionIds();
      SetStateIds();
     }
  }, [SelectDate?.value]);

  useMemo(() => {
    if (SelectDate?.value > 0 && SelectRegionDetails?.RegionId) {
      StatePerformance();
    }
  }, [SelectRegionDetails?.RegionId]);

  const RenderStateDetails = (e) => {
    const value = RegionIds.filter(
      (item) => item.value === parseInt(e.target.value)
    );
    SetSelectRegionDetails({
      RegionName: value[0].display,
      RegionId: e.target.value,
    });
  };
  const OPenDistrictDrillDown = (State) => {
    // localStorage.setItem("PerformanceDate", JSON.stringify(GetAssessmentdate));
    dispatch(
      AllSubjectData({
        RegionDetails: [
          {
            display: SelectRegionDetails?.RegionName,
            value: SelectRegionDetails?.RegionId,
          },
        ],
      })
    );

    const value = StateIds.filter((item) => item.display === State);
    dispatch(StateDetailsData({ StateDetails: value }));
    navigate(
      `/InstitutionAdmin/Performance/RegionPerformanceDetails/StatePerformanceDetails`
    );
  };
    useMemo(() => {
     dispatch(
          AllSubjectData({
            RegionDetails: [
              {
                Region: SelectRegionDetails?.RegionName,
                Regionid: SelectRegionDetails?.RegionId,
              },
            ],
          })
        );
    
    }, [SelectRegionDetails]);
    //  4th May 2026 Export the table data in Excel Format
  const exportToExcel = () => {
    const table = document.getElementById("performanceTable");

    if (!table) {
      alert("Table not found!");
      return;
    }

    const worksheet = XLSX.utils.table_to_sheet(table, { raw: true });
    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });

        if (!worksheet[cellAddress]) continue;

        worksheet[cellAddress].s = {
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    }

    if (worksheet["A1"]) {
      worksheet["A1"].s = {
        ...worksheet["A1"].s,
        font: {
          bold: true,
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    }
    if (worksheet["A5"]) {
      worksheet["A5"].s = {
        ...worksheet["A5"].s,
        font: {
          bold: true,
        },
      };
    }

    for (let C = range.s.c; C <= range.e.c; C++) {
  const cellAddress = XLSX.utils.encode_cell({
    r: 1,
    c: C,
  });

  if (!worksheet[cellAddress]) continue;

  worksheet[cellAddress].s = {
    ...worksheet[cellAddress].s, // keep border
    font: {
      ...(worksheet[cellAddress].s?.font || {}),
      bold: true,
    },
    alignment: {
      horizontal: "center",
      vertical: "center",
    },
  };
}

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Region Performance");

    XLSX.writeFile(workbook, "Region_Performance ${SelectDate?.assessmentTypeName}_${SelectDate?.examStartDate}.xlsx");
  };
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        {/* <b className="CPointer" onClick={()=>navigate(-1)}>{SelectRegionDetails?.RegionName}</b> */}
     <div className="dflex JSBetween alignitems">
      <div></div>
        <div className="MainHeading">
         {SelectRegionDetails?.RegionName} Region Performance in {CAssessmentName(SelectDate?.assessmentType)} - {SelectDate?.examStartDate}
        </div>
        {/*   4th May 2026 Trigger the export excel function */}
        <div className="ExportExcel" onClick={() => exportToExcel()}> {StateWisedata?.[0]?.state &&<RiFileExcel2Fill />} </div>
        </div>
        <div className="dflex JSBetween alignitems mt-1">
          <div></div>
          <b><span ><span className="CPointer text-decoration-underline" onClick={()=>navigate(-1)} style={{color:"#696969"}}>National</span>{""} &gt; {""}</span> <span style={{color:"#00009A"}}>{SelectRegionDetails?.RegionName}</span></b>
           <div></div>
        </div>
        <div className="dflex JSBetween mb-2 ">
            <div></div>
        <div className="dflex" style={{ gap: "10px" }}>
            {RegionIds && (
              <div className="dflex gap-2">
              <div className="DropdownHeader">Region:</div>
              <DropdownValues
                className="NCLDropdown"
                options={RegionIds}
                onChange={(e) => RenderStateDetails(e)}
                selectoption={SelectRegionDetails?.RegionId}
                // labelname={}
              />
              </div>
            )}

          </div>
          </div>
        <div className="Table-Card">
          {StateWisedata?.[0]?.state ? (
            <table className="w-100 Inst_Performance-Table" id="performanceTable">
              <thead>
                <tr>
                   {/* {SelectRegionDetails?.RegionName} region */}
                  <th colSpan={NSData?.length + 1}>
                    Performance report
                  </th>
                </tr>
                <tr>
                  <th></th>
                  {NSData?.map((item, index) => (
                    <th key={index}>{item.subjectName}(%)</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr style={{ color: "#7030a0" }}>
                  <th className="ft-18 CPointer text-decoration-underline" onClick={()=>navigate(-1)} >National</th>
                  {NSData?.map((item, index) => (
                    <td key={index}>{item.percentage}%</td>
                  ))}
                </tr>
                <tr style={{ color: "#008080" }}>
                  <th >
                    {SelectRegionDetails?.RegionName}
                  </th>
                  {RegionP?.map(
                    (item, index) =>
                      item.region === SelectRegionDetails?.RegionName &&
                      NSData?.map((Subject, index) => (
                        <td key={index}>
                          {item[Subject.subjectName] === "N/A" ||
                          item[Subject.subjectName] === undefined
                            ? "-"
                            : item[Subject.subjectName] + "%"}
                        </td>
                      ))
                  )}
                </tr>
                <tr>
                  <th
                    colSpan={NSData?.length + 1}
                    style={{ textAlign: "justify" }}
                  >
                    {" "}
                    {SelectRegionDetails?.RegionName} Region - States
                    Performance
                  </th>
                </tr>
                {StateWisedata?.map((item, index) => (
                  <tr key={index} >
                    <th
                      className="text-decoration-underline CPointer"
                      // style={{ color: "#259957" }}
                      style={{ color: Colors[1] }}
                      onClick={() => {
                        OPenDistrictDrillDown(item.state);
                      }}
                    >
                      {item.state}
                    </th>
                    {NSData?.map((Subject, index) => (
                      <td key={index}>
                        {item[Subject.subjectName] === "N/A" ||
                        item[Subject.subjectName] === undefined
                          ? "-"
                          : item[Subject.subjectName] + "%"}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="ErrorMessage">{StateWisedata}</div>
          )}
        </div>

        <div className="SubHeading mt-3">
          Region vs State performance trends
        </div>
        <div className="container-fluid">
          <Row className=" Card mt-3 dflex" style={{ gap: "10px" }}>
            <div className="dflex RegionSub-Navigations">
              {Subjects?.map((item, index) => (
                <span
                  key={index}
                  onClick={() => {
                    SetSelectSub(item);
                  }}
                  style={
                    SelectSUb !== item
                      ? { color: "#878997", backgroundColor: "#f5f5f5" }
                      : {}
                  }
                >
                  {item}
                </span>
              ))}
            </div>
            <Col style={{ borderRight: "1px solid #CBCBCB" }}>
              {" "}
              <RLineTrends
                AType={SelectDate?.assessmentType}
                Regions={RegionIds}
                SubSelect={SelectSUb}
                SelectedRegion={SelectRegionDetails}
                StoreSubjects={SetSubjects}
                StoreSelSub={SetSelectSub}
              />{" "}
            </Col>
            <Col>
              {StateIds && (
                <StateTrends
                  AType={SelectDate?.assessmentType}
                  SubSelect={SelectSUb}
                  /*SelectedRegion={SelectRegionDetails}*/ StateIds={StateIds}
                />
               )}{" "}
            </Col>
          </Row>
        </div>

        {/*   <div className="Card mt-3">
          <div className="dflex RegionSub-Navigations">
            {Subjects?.map((item, index) => (
              <span key={index} onClick={() => { SetSelectSub(item) }} style={SelectSUb !== item ? { color: "#878997", backgroundColor: "#f5f5f5" } : {}}>{item}</span>))}</div>

          <StateTrends AType={TesType} SubSelect={SelectSUb} SelectedRegion={SelectRegionDetails} StateIds={StateIds}/>
        </div> */}
        {/* <CopyRight /> */}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default RegionPerformanceDrillDown;
